import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Box, IconButton, Paper, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDialogBetter } from "../../../hooks/useDialogBetter";
import { useProductTags } from "../../../services/productsService";
import { AddTagDialog } from "./AddTagDialog";

export const ProductTagsSelector = (props) => {
    const { formTagIds, setFormTagIds, readOnly = false } = props;
    const { t } = useTranslation();
    const { openDialog } = useDialogBetter();

    const handleOpenAddTagDialog = () => {
        if (readOnly) {
            return;
        }
        openDialog({
            Component: AddTagDialog,
            componentProps: {
                formTagIds,
                setFormTagIds,
            },
        });
    };

    const { data: filteredTags } = useProductTags(new URLSearchParams(), {
        select: (allTags) => allTags.filter((tag) => formTagIds.includes(tag.id)),
    });

    const hadleDeleteTag = (tagId)=>{
        if (readOnly) return
        setFormTagIds(formTagIds.filter(tag=> tag !== tagId))
    }
    
    return (
        <Paper
            sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
                margin: "1rem",
                padding: "1rem",
            }}
        >
            <Box display="flex" flexDirection="row" justifyContent="space-between" width="100%">
                <Typography variant="h3" align="left" sx={{ width: "100%", fontSize: "1.5rem" }}>
                    {t("products.ProductTagsSelector.title")}
                </Typography>
                {!readOnly && (
                    <IconButton onClick={handleOpenAddTagDialog}>
                        <AddCircleIcon />
                    </IconButton>
                )}
            </Box>
            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1,
                    width: "100%",
                }}
            >
                {filteredTags?.map((tag) => (
                    <Box
                        key={tag.id}
                        sx={{
                            border: "1px solid",
                            borderColor: readOnly ? "#e0e0e0" : "primary.light",
                            borderRadius: "8px",
                            padding: "0.5rem 1rem",
                            color: readOnly ? "#9e9e9e" : "primary.light",
                            backgroundColor: readOnly ? "#f5f5f5" : "transparent",
                            position: "relative",
                            cursor: readOnly ? undefined : "pointer"
                        }}
                        onClick={()=>hadleDeleteTag(tag.id)}
                    >
                        {!readOnly && <Typography variant="body2" style={{position: "absolute", top: "0px", right: "4px"}}>x</Typography>}
                        <Typography variant="body2">{tag.tag_name}</Typography>
                    </Box>
                ))}
                {filteredTags?.length === 0 && (
                    <Typography variant="body2" color="textSecondary">
                        {t("products.ProductPassport.noTags")}
                    </Typography>
                )}
            </Box>
        </Paper>
    );
};
